import styled from '@emotion/styled';

export const TotalIncome = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
`;

export const Income = styled.div`
  display: flex;
  font-weight: bold;
  margin-left: 8px;
  font-weight: bold;
`;

export const ItemsPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #172b4d;
  margin: 0 20px;
`;

export const NoItems = styled.div`
  text-align: center;
`;

export const WorklogsBackButton = styled.a`
  border: none;
  box-shadow: none;
  color: #172b4d;
  font-weight: 400;
  background-color: rgba(9, 30, 66, 0.08);
  text-align: left;
  cursor: pointer;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  padding: 0 4px;
  line-height: 20px;
  text-decoration: none;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  &:hover {
    color: #172b4d;
    background-color: rgba(9, 30, 66, 0.13);
    font-weight: 400 !important;
    box-shadow: none;
  }
  &:active {
    display: inline-flex;
    line-height: 20px;
    background-color: rgba(9, 30, 66, 0.25);
    box-shadow: none;
  }
`;

export const AddWorklogButton = styled(WorklogsBackButton)`
  margin-right: 8px;
`;

export const Divider = styled.hr`
  margin: 8px 0 0;
`;

export const TransactionsList = styled.div`
  margin-top: 10px;
  margin-left: 10px;
  flex: 1 0 50%;
  display: flex;
  flex-direction: column;
`;
